<template>
    <div class="main_wrapper">
        <div class="inner">
            <div class="doc_heading">
                <h1>Getting Started</h1>
            </div>
            <div class="doc_content">
                <p>We use a RESTful API that lets you access users' replug data, like their call-to-actions, links and
                    more. The Replug API uses OAUTH and allows both read and write permissions when interacting with a
                    user's content.
                </p>
                <p>
                    To start, you’ll need to set up an app.
                </p>
                <h2>App development</h2>
                <p>In order to use our API, you’ll need to create an app. Once you’ve created an app, you’ll be able to
                    test it and integrate it into your platform.
                </p>

                <h2>Create Your Application</h2>
                <p>
                    You’ll need to be logged in to your Replug account to create an app. If you don’t have a Replug
                    account, <a href="https://app.replug.io/register">create one now.</a> To create a new app:
                </p>

                <ul class="list-bullet list-bullet-disc">
                    <li>
                        Go to Settings, and navigate to the Apps section.

                        <img src="../../assets/img/intro/apps-navigation.png" alt="app-navigation">
                    </li>
                    <li>
                        Click on the create new Application button.
                        <img src="../../assets/img/intro/new-application.png" alt="new-application">
                    </li>
                    <li>
                        Choose a name and redirect URL for your app. Click Create.
                        <img src="../../assets/img/intro/create-new-application.png" alt="create-new-application">
                    </li>
                    <li>
                        Once your app has been created, you will see the Client ID and Client Secret for your newly
                        <img src="../../assets/img/intro/application-listing.png" alt="create-new-application">
                    </li>
                </ul>

                <p>
                    That's all you need to do to create your application. Once you are done, next you need to integrate
                    it with your platform.
                </p>




                <!--<div class="doc_row">
                    <div class="left_block">
                        <h2>Things you should know</h2>
                        <div class="alert_box warning">
                            <div class="inner_box">
                                <h4><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Warning</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <p>helps deliver and track transactional emails for
                            web applications. In a nutshell, the service replaces SMTP (or S
                            endmail) with a far more reliable, scalable and care-free environment.
                            In addition, you can track statistics such as number of emails sent or p
                            rocessed, opens, bounces and spam complaints.
                        </p>
                        <div class="alert_box success">
                            <div class="inner_box">
                                <h4><i class="fa fa-check " aria-hidden="true"></i> Success</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <p>helps deliver and track transactional emails for
                            web applications. In a nutshell, the service replaces SMTP (or S
                            endmail) with a far more reliable, scalable and care-free environment.
                            In addition, you can track statistics such as number of emails sent or p
                            rocessed, opens, bounces and spam complaints.
                        </p>

                        <div class="alert_box danger">
                            <div class="inner_box">
                                <h4><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Danger</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <div class="code_table">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>Property</th>
                                    <th>Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>use_custom_confirmation_page</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>



                    </div>
                    <div class="right_block">
                        <div class="code_block">
              <pre v-highlightjs>
                <code class="javascript">
   export default {
     name: 'HelloWorld',
     data () {
     return {
          msg: 'Welcome to Yoeome to Your Vue.jsWelcome to Your Vue.js App'
          }
        }
    }
                </code>
              </pre>
                        </div>
                        <div class="code_block">
              <pre v-highlightjs>
                <code class="less">
  .code_table{
  .table{
    border: 1px solid #e1e4e5;
    thead th{
      border-top: 0;
      border-bottom: 1px solid #e1e4e5;
      font-weight: bold;
      font-size: 16px;
    }
    tbody{
      tr{
        &:nth-child(odd){
          background-color: #f3f6f6;
        }
        //&:nth-child(even){
        //  background-color: fade(#f9f9f9,44%);
        //}
        td{
          font-size: 15px;
          border-top: 1px solid #e1e4e5;
          border-right:1px solid #e1e4e5;
          //word-break: break-all;
        }
      }
    }
  }
}
                </code>
              </pre>
                        </div>

                    </div>
                </div>

                <div class="doc_row">
                    <div class="left_block">
                        <h2>Things you should know</h2>
                        <div class="alert_box warning">
                            <div class="inner_box">
                                <h4><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Warning</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <p>helps deliver and track transactional emails for
                            web applications. In a nutshell, the service replaces SMTP (or S
                            endmail) with a far more reliable, scalable and care-free environment.
                            In addition, you can track statistics such as number of emails sent or p
                            rocessed, opens, bounces and spam complaints.
                        </p>
                        <div class="alert_box success">
                            <div class="inner_box">
                                <h4><i class="fa fa-check " aria-hidden="true"></i> Success</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <p>helps deliver and track transactional emails for
                            web applications. In a nutshell, the service replaces SMTP (or S
                            endmail) with a far more reliable, scalable and care-free environment.
                            In addition, you can track statistics such as number of emails sent or p
                            rocessed, opens, bounces and spam complaints.
                        </p>

                        <div class="alert_box danger">
                            <div class="inner_box">
                                <h4><i class="fa fa-exclamation-circle" aria-hidden="true"></i> Danger</h4>
                                <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum neectetur adipisicing elit. A earum impedit nulla
                                    , rem rerum voluptate? Ad cum nemo quos mo quos vel.</p>
                            </div>
                        </div>

                        <div class="code_table">
                            <table class="table">
                                <thead>
                                <tr>
                                    <th>Property</th>
                                    <th>Description</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>use_custom_confirmation_page</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                <tr>
                                    <td>status</td>
                                    <td>A read-only Drip generated unique id used to identify each campaign record.</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>



                    </div>
                    <div class="right_block">
                        <div class="code_block">
              <pre v-highlightjs>
                <code class="javascript">
   export default {
     name: 'HelloWorld',
     data () {
     return {
          msg: 'Welcome to Yoeome to Your Vue.jsWelcome to Your Vue.js App'
          }
        }
    }
                </code>
              </pre>
                        </div>
                        <div class="code_block">
              <pre v-highlightjs>
                <code class="less">
  .code_table{
  .table{
    border: 1px solid #e1e4e5;
    thead th{
      border-top: 0;
      border-bottom: 1px solid #e1e4e5;
      font-weight: bold;
      font-size: 16px;
    }
    tbody{
      tr{
        &:nth-child(odd){
          background-color: #f3f6f6;
        }
        //&:nth-child(even){
        //  background-color: fade(#f9f9f9,44%);
        //}
        td{
          font-size: 15px;
          border-top: 1px solid #e1e4e5;
          border-right:1px solid #e1e4e5;
          //word-break: break-all;
        }
      }
    }
  }
}
                </code>
              </pre>
                        </div>

                    </div>
                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'HelloWorld',
        data () {
            return {
                msg: 'Welcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.jsWelcome to Your Vue.js App'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/intro/Introduction.vue